module.exports = __webpack_public_path__ + "static/media/phil4.4f603b4f.png";